const isPhotoColorizer = location.pathname.includes('photo-colorizer');
import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    originalImageKey: 'ai/input/image-group/',
    resultImageKey: 'ai/export/image-group/',
    historyListType: 4,
    freeLimitType: 'image-manipulation',
    currentMenuName: !isPhotoColorizer ? 'ai-old-photo-restoration' : 'ai-photo-colorizer',
    colorizerImageUrl:
        environment === LOCAL
            ? `/public/resource/ai-image-manipulation/colorize-img/`
            : `/app/ai-tools/resource/ai-image-manipulation/colorize-img/`,
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/resource/ai-image-manipulation/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/resource/ai-image-manipulation/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/resource/ai-image-manipulation/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/resource/ai-image-manipulation/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    eraseTipsVideoUrl:
        environment === LOCAL
            ? `/public/img/oldPhotoRestoration/erase-tips.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/oldPhotoRestoration/erase-tips.mp4?v=${FJVersionConfig.staticPathVersion}`,
};
